import styled from 'styled-components/macro';

import { colors, cardColorScheme } from '../../../styles/vars';

const QuoteAuthor = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-width: 190px;
  margin: 20px 0 0 auto;
  padding: 2px 5px;
  color: ${colors['black-six']};

  .textLength {
    align-self: flex-end;
  }

  .public-DraftEditor-content {
    text-align: right;
    font-size: 16px;
  }

  &::before {
    content: '';
    position: absolute;
    left: -20px;
    top: 12px;
    width: 15px;
    height: 1px;
    border-top: 1px solid ${({ colorScheme }) => colorScheme && cardColorScheme[colorScheme].color};
  }
`;

export default QuoteAuthor;
